<template>
<div class="edi-allorderbill">
	<navbar title="餐企报价单"></navbar>
	<div class="common-scroll" id="common-scroll" @scroll="refresh" style="bottom:0">
		<div class="filter">
			<input type="text" v-model="keyword" class="ui-search-input" :class="{'ui-search-input2':filterShow, 'ui-search-input1': !filterShow}" @keyup.enter="enterSearch"/>
			<a class="ui-filter-icon" @click="move"></a>
		</div>
		<div class="container">
			<ul class="ui-listview" style="padding-bottom: 0">
				<li v-for="bill in billList" :key=bill.id>
					<router-link :to="{ path: '/detail-quotation-bill', query: { bill_id: bill.id }}">
						<p class="allorderbill-list-p">{{bill.restaurant_name}}
						<span v-if="bill.bill_state == 30" class="grey-font"><i></i>未确认</span>
						<span v-if="bill.bill_state == 31" class="aqua-font"><i></i>已同意</span>
						<span v-if="bill.bill_state == 32" class="red-font"><i></i>已确认</span>
						<span v-if="bill.bill_state == 35" class="red-font"><i></i>已定价</span>
						</p>
						<ul class="ui-detail-listview ui-detail-listviews">
							<li>单号：{{bill.trans_bill_no}}</li>
							<li>报价日期：{{dateCut(bill.from_date)}}</li>
							<li v-show="bill.in_date" style="width: 70%">
								报价截止时间：{{formatDate(bill.in_date)}}
							</li>
						</ul>
						<p class="allorderbill-total-p">共<strong>{{bill.detail_num}}</strong>种品项</p>
					</router-link>
				</li>
			</ul>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<loading v-show="loading"></loading>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<bill-filter :filterBillState="queryData.bill_state"
		:filterTitle="`餐企报价单筛选`"
		:filterBillFont="queryData.bill_font"
		:filterStarDate="queryData.start_date"
		:filterEndDate="queryData.end_date" ref="billFilterOpen" v-on:confirm="backValue"
	></bill-filter>
</div>
</template>
<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
import BillFilterComponent from '../components/BillFilterComponent'
import BillStatusSelect from '../components/BillStatusSelectL'
export default {
	data () {
		return {
			filterShow: true,
			filterPageShow: false,
			show: true,
			cls: '',
			font: '',
			midware: true,
			icon: '',
			midFont: '',
			loading: true,
			tips: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			billList: [],
			bill_type: 3,
			keyword: '',
			length: 10,
			start: 0,
			filterData: {},
			prevLength: 0,
			back_state: '30,31,32',
			bill_state: '',
			back_state_font: '',
			start_date: '',
			end_date: '',
			store: GlobalStore,
			goodsTotalInfo: {},
			billFilterData: {}
		}
	},
	components: {
		'bill-filter': BillFilterComponent,
		'loading': Loading,
		'tips': Tips,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'bill-status-select': BillStatusSelect,
		'navbar': NavBar
	},
	created () {
		if (this.queryData.filterShow === false) {
			this.filterShow = false
		}
		// 如果有筛选条件,按照筛选条件查询 shang 2017/10/19
		this.billFilterData = this.store.billFilterData
		if (this.billFilterData.filterFlag) {
			this.queryData.bill_state = this.billFilterData.filterBillState
			this.queryData.bill_font = this.billFilterData.filterBillStateFont
			this.queryData.start_date = this.billFilterData.filterStartDate
			this.queryData.end_date = this.billFilterData.filterEndDate
			this.start_date = this.billFilterData.filterStartDate
			this.end_date = this.billFilterData.filterEndDate
		}
		this.loading = true
		this.bill_state = this.queryData.bill_state
		this.bill_state_font = this.queryData.bill_font
		var billState = this.bill_state
		var billType = this.bill_type
		var keyWord = this.keyword
		var startDate = this.start_date
		var endDate = this.end_date
		this.filterData = {
			bill_state: billState,
			start_date: startDate,
			end_date: endDate,
			bill_type: billType,
			keyword: keyWord,
			length: 10,
			start: 0
		}
		this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
			this.loading = false
			this.billList = response.body.data
			if (this.billList === null) {
				this.midware = true
				this.icon = 'middle-empty'
				this.midFont = '没有数据'
				return false
			}
			this.prevLength = this.billList.length
			// window.console.log(this.prevLength)
		}, (response) => {
			this.loading = false
			this.midware = true
			this.icon = 'middle-net'
			this.midFont = '服务中断，稍后请重试！'
		})
	},
	methods: {
		move () {
			var obj = {
				back_state: this.bill_state,
				back_state_font: this.bill_state_font
			}
			this.$refs.billFilterOpen.move(obj)
		},
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		refresh () {
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			// window.console.log(marginBot)
			if (marginBot <= 1) {
				this.show = false
				if (this.prevLength < 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var billState = this.bill_state
				var billType = this.bill_type
				var keyWord = this.keyword
				var startDate = this.start_date
				var endDate = this.end_date
				this.filterData = {
					bill_state: billState,
					start_date: startDate,
					end_date: endDate,
					bill_type: billType,
					keyword: keyWord,
					length: 10,
					start: start
				}
				this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
					var data = response.body.data
					this.show = true
					this.prevLength = data.length
					// window.console.log(this.prevLength)
					this.billList = this.billList.concat(data)
					// window.console.log(data)
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		// backValue (msg) {
		// 	window.console.log(msg)
		// 	this.queryData.bill_state = msg.bill_state
		// 	this.queryData.start_date = msg.start_date
		// 	this.queryData.end_date = msg.end_date
		// 	this.search()
		// },
		selectBillStatus (flag, font) {
			this.$refs.billStatuselectShow.open(flag, font)
		},
		getBillStatus (msg) {
			this.bill_state = msg[0].join(',')
			this.bill_state_font = msg[1].join(',')
		},
		// 修复筛选无效 shang 2017/10/19
		backValue (msg) {
			if (this.bill_state.length === 0) {
				this.tips = true
				this.tipsFont = '请至少选择一种单据状态'
				return false
			}
			this.bill_state = msg.bill_state
			this.bill_state_font = msg.bill_state_font
			this.start_date = msg.start_date
			this.end_date = msg.end_date
			this.billFilterData.filterFlag = true
			this.billFilterData.filterStartDate = this.start_date
			this.billFilterData.filterEndDate = this.end_date
			this.billFilterData.filterBillState = this.bill_state
			this.billFilterData.filterBillStateFont = this.bill_state_font
			this.filterPageShow = false
			this.search()
		},
		search () {
			this.loading = true
			this.midware = false
			var billState = this.bill_state
			var startDate = this.start_date
			var billType = this.bill_type
			var endDate = this.end_date
			var sortMethod = this.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				bill_type: billType,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			// this.$router.push({path: '/all-return-bill', query: this.filterData})
			this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
				this.loading = false
				this.billList = response.body.data
				if (this.billList === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		// 搜索栏回车搜索,实现明细退回单据主页面,依然存在搜索条件 shang 2017/10/19
		enterSearch () {
			this.loading = true
			this.midware = false
			var billState = this.queryData.bill_state
			var billType = this.bill_type
			var startDate = this.start_date
			var endDate = this.end_date
			var sortMethod = this.queryData.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				bill_type: billType,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			// this.$router.push({path: '/all-return-bill', query: this.filterData})
			this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
				this.loading = false
				this.billList = response.body.data
				if (this.billList === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		formatDate (datetime) {
			if (!datetime || datetime.indexOf('1970-01-01') === 0) {
				return ''
			}

			var d = this.$fxUtils.newDate(datetime)
			return this.$fxUtils.setDateTime(d, '时分')
		}
	}
}
</script>



// WEBPACK FOOTER //
// QuotationBill.vue?7e0ed7b8